function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSterilizerSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sterilizer_small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon 16px",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3697",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(1431 13)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13420"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46607",
    d: "M143.329 26.345a2.346 2.346 0 0 0-3.972 2.415 3.948 3.948 0 0 1 3.972-2.415z",
    transform: "translate(1293.379 -6.131)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46608",
    d: "M154.425 21.071a3.467 3.467 0 0 0-6.764 0 5.24 5.24 0 0 1 6.764 0z",
    transform: "translate(1287.967 -1.605)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46609",
    d: "M150.681 29.947a3.984 3.984 0 0 1 4.569 0 2.333 2.333 0 0 0-4.569 0z",
    transform: "translate(1286.044 -7.795)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46610",
    d: "M147.315 33.506a1.655 1.655 0 0 0-2.816 1.712 2.854 2.854 0 0 1 2.816-1.712z",
    transform: "translate(1290.089 -10.816)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46611",
    d: "M163.3 26.345a2.346 2.346 0 0 1 3.972 2.415 3.949 3.949 0 0 0-3.972-2.415z",
    transform: "translate(1278.008 -6.131)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46612",
    d: "M161.39 33.506a1.655 1.655 0 0 1 2.816 1.712 2.854 2.854 0 0 0-2.816-1.712z",
    transform: "translate(1279.227 -10.816)",
    style: {
      fill: "#08232f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46613",
    d: "M150.681 38.709a3.984 3.984 0 0 1 4.569 0 2.333 2.333 0 0 0-4.569 0z",
    transform: "translate(1286.044 -13.373)",
    style: {
      fill: "#08232f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSterilizerSmall);
export default __webpack_public_path__ + "static/media/sterilizer_small.a69dcc6c1a66a4d848acd807082b0e65.svg";
export { ForwardRef as ReactComponent };